export default {
  selectors: {
    card: '[data-comp-generic-card]',
    cardFiltering: '[data-comp-card-filtering]',
    cards: '[data-comp-card-filtering-cards]',
    moreButton: '[data-comp-card-filtering-more-button]',
    moreSection: '[data-comp-card-filtering-more-section]',
    categoryId: '[data-comp-card-filtering-more-category]',
  },
};
